export default __webpack_public_path__ + "static/media/icon-calendar-white.5043abda.svg";